module.exports = __webpack_public_path__ + "static/media/Air55_in.9363538c.jpg";